import Button from "components/buttons/Button";
import type { FunctionComponent, PropsWithChildren } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Headline from "~/components/Headline";
import Hint from "~/components/Hint";
import LoadingSpinnerFull from "~/components/LoadingSpinners/LoadingSpinnerFull";
import Modal from "~/components/Modal";
import { normalizeTKey } from "~/types/typeHelpers.ts";

export type DeleteEntityTextElements = {
	headerText: string;
	bodyText: string;
	confirmationText?: string;
	deleteButtonText: string;
	confirmationButtonText?: string;
};

interface DeleteEntityViewProps extends PropsWithChildren {
	busy: boolean;
	onCloseClick: () => void;
	error?: string | null;
	handleConfirmationClick: () => void;
	isOpen: boolean;
	texts: DeleteEntityTextElements;
}

const DeleteEntityView: FunctionComponent<DeleteEntityViewProps> = ({
	busy,
	isOpen,
	children,
	onCloseClick,
	error,
	handleConfirmationClick,
	texts,
}) => {
	const { t } = useTranslation();
	const [showConfirmation, setShowConfirmation] = useState(false);
	useEffect(() => {
		if (isOpen) {
			setShowConfirmation(false);
		}
	}, [isOpen]);
	return (
		<Modal open={isOpen}
			   setOpen={onCloseClick}>
			<div className="flex flex-col gap-3">
				<Headline type="h4"
						  colorClassName="text-gray-600">{texts.headerText}</Headline>
				{busy ? (
					<LoadingSpinnerFull />
				) : (
					<>
						<div>
							{children}
							{!showConfirmation && <p>{texts.bodyText}</p>}
							{showConfirmation && !error &&
								<p>{texts.confirmationText || "Bist du sicher? Das Löschen kann nicht rückgängig gemacht werden!"}</p>}
							{showConfirmation && error && <Hint size="sm"
																theme="error">{error}</Hint>}
						</div>
						<div className="mt-4">
							{!showConfirmation && (
								<Button theme="danger"
										onClick={() => setShowConfirmation(true)}>
									{texts.deleteButtonText}
								</Button>
							)}
							{showConfirmation && !error && (
								<Button theme="danger"
										onClick={handleConfirmationClick}>
									{texts.confirmationButtonText || "Endgültig löschen"}
								</Button>
							)}
							<Button theme="none"
									onClick={onCloseClick}>
								{t(normalizeTKey("form:buttonTexts.cancel"))}
							</Button>

						</div>
					</>
				)}
			</div>
		</Modal>
	);
};

export default DeleteEntityView;
